import React, { useState, useRef, useEffect } from 'react';
import './Sidebar.css';
import { temPermissao } from '../utils/permissoes';

function corAvatar(email) {
  let hash = 0;
  for (let i = 0; i < (email || '').length; i++) {
    hash = (email || '').charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${Math.abs(hash) % 360}, 60%, 45%)`;
}

function iniciais(nome) {
  return (nome || '').trim().split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');
}

function Sidebar({ paginaAtiva, setPagina, badgeObras, usuario, onLogout, aberta, onFechar, tema, onAlternarTema, tenantStatus }) {
  const [cadastrosAberto, setCadastrosAberto] = useState(true);
  const [configAberto, setConfigAberto] = useState(false);
  const [menuUsuarioAberto, setMenuUsuarioAberto] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickFora(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuUsuarioAberto(false);
      }
    }
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, []);

  const diasTrial = tenantStatus?.status === 'trial' && tenantStatus?.data_vencimento
    ? Math.ceil((new Date(tenantStatus.data_vencimento) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  // Teste grátis sem data de vencimento (plano gratis)
  const trialGratis = tenantStatus?.status === 'trial' && !tenantStatus?.data_vencimento;

  const menusPrincipais = [
    { id: 'dashboard', label: '🏠 Início' },
    temPermissao('financeiro_ver') && { id: 'financeiro', label: '💰 Financeiro' },
    { id: 'contatos', label: '👥 Contatos' },
    { id: 'obras', label: '🏗️ Obras' },
  ].filter(Boolean);

  const menusCadastros = temPermissao('cadastros_editar') ? [
    { id: 'servicos', label: 'Serviços' },
    { id: 'formas-pagamento', label: 'Formas de Pagamento' },
  ] : [];

  const menusConfig = [
    { id: 'plano', label: '💎 Plano' },
    temPermissao('configuracoes_editar') && { id: 'empresa', label: '🏢 Empresa' },
    temPermissao('configuracoes_editar') && { id: 'configuracoes', label: 'SINAPI' },
    temPermissao('usuarios_gerenciar') && { id: 'usuarios', label: '👤 Usuários' },
  ].filter(Boolean);

  return (
    <div className={`sidebar${aberta ? ' aberta' : ''}`}>
      <button className="sidebar-close-btn" onClick={onFechar} aria-label="Fechar menu">✕</button>
      <div className="sidebar-logo">
        <img src="/LogoComNomeDaEmpresa.png" alt="CronoObra" style={{ height: 54, width: 'auto', maxWidth: '100%', filter: 'brightness(0) invert(1)' }} />
      </div>

      {trialGratis && (
        <div
          onClick={() => setPagina('plano')}
          style={{
            margin: '8px 12px', background: '#78350f', border: '1px solid #d97706',
            borderRadius: 8, padding: '10px 12px', cursor: 'pointer',
          }}
        >
          <p style={{ margin: 0, fontSize: 12, fontWeight: 700, color: '#fef3c7' }}>🎉 Teste grátis — 1 obra</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#fde68a' }}>Assine um plano para liberar mais →</p>
        </div>
      )}

      {diasTrial !== null && diasTrial <= 7 && (
        <div
          onClick={() => setPagina('plano')}
          style={{
            margin: '8px 12px',
            background: diasTrial <= 1 ? '#7f1d1d' : '#78350f',
            border: `1px solid ${diasTrial <= 1 ? '#dc2626' : '#d97706'}`,
            borderRadius: 8,
            padding: '10px 12px',
            cursor: 'pointer',
          }}
        >
          <p style={{ margin: 0, fontSize: 12, fontWeight: 700, color: '#fef3c7' }}>
            {diasTrial <= 0 ? 'Trial expirado!' : diasTrial === 1 ? 'Último dia de trial!' : `Trial: ${diasTrial} dias restantes`}
          </p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#fde68a' }}>Clique para ver seu plano →</p>
        </div>
      )}

      <button
        className="sidebar-busca-btn"
        onClick={() => window.dispatchEvent(new Event('busca-abrir'))}
        title="Busca global (Ctrl+K)"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
        </svg>
        <span>Buscar...</span>
        <kbd>Ctrl+K</kbd>
      </button>

      <nav>
        {menusPrincipais.map((menu) => (
          <button
            key={menu.id}
            className={`sidebar-item ${paginaAtiva === menu.id ? 'ativo' : ''}`}
            onClick={() => setPagina(menu.id)}
          >
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>{menu.label}</span>
              {menu.id === 'obras' && badgeObras > 0 && (
                <span className="sidebar-badge">{badgeObras}</span>
              )}
            </span>
          </button>
        ))}

        {menusCadastros.length > 0 && (
          <>
            <button
              className="sidebar-secao"
              onClick={() => setCadastrosAberto(!cadastrosAberto)}
            >
              <span>📋 Cadastros</span>
              <span className={`sidebar-seta ${cadastrosAberto ? 'aberto' : ''}`}>▼</span>
            </button>
            {cadastrosAberto && menusCadastros.map((menu) => (
              <button
                key={menu.id}
                className={`sidebar-item sidebar-subitem ${paginaAtiva === menu.id ? 'ativo' : ''}`}
                onClick={() => setPagina(menu.id)}
              >
                {menu.label}
              </button>
            ))}
          </>
        )}

        {menusConfig.length > 0 && (
          <>
            <button
              className="sidebar-secao"
              onClick={() => setConfigAberto(!configAberto)}
            >
              <span>⚙️ Configurações</span>
              <span className={`sidebar-seta ${configAberto ? 'aberto' : ''}`}>▼</span>
            </button>
            {configAberto && menusConfig.map((menu) => (
              <button
                key={menu.id}
                className={`sidebar-item sidebar-subitem ${paginaAtiva === menu.id ? 'ativo' : ''}`}
                onClick={() => setPagina(menu.id)}
              >
                {menu.label}
              </button>
            ))}
          </>
        )}
      </nav>

      <div style={{ margin: '8px 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
        <a
          href="https://www.cronoobra.com.br/tutorial"
          target="_blank"
          rel="noreferrer"
          style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 14px', borderRadius: 8, background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: 13, fontWeight: 500 }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.13)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.07)'}
        >
          <span style={{ fontSize: 15 }}>📄</span>
          Tutorial — primeiros passos
        </a>
        <a
          href="https://www.cronoobra.com.br/status"
          target="_blank"
          rel="noreferrer"
          style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 14px', borderRadius: 8, background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: 13, fontWeight: 500 }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.13)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.07)'}
        >
          <span style={{ fontSize: 15 }}>🟢</span>
          Status do sistema
        </a>
      </div>

      {usuario && (
        <div className="sidebar-perfil-container" ref={menuRef}>
          {menuUsuarioAberto && (
            <div className="sidebar-perfil-dropdown">
              <button onClick={() => { setPagina('perfil'); setMenuUsuarioAberto(false); }}>
                👤 Meu Perfil
              </button>
              <button onClick={() => { onAlternarTema(); setMenuUsuarioAberto(false); }}>
                {tema === 'dark' ? '☀️ Tema Claro' : '🌙 Tema Escuro'}
              </button>
              <button className="sidebar-dropdown-sair" onClick={onLogout}>
                🚪 Sair
              </button>
            </div>
          )}
          <button
            className="sidebar-perfil-btn"
            onClick={() => setMenuUsuarioAberto(!menuUsuarioAberto)}
          >
            {usuario.foto ? (
              <img src={usuario.foto} alt="avatar" className="sidebar-avatar" style={{ objectFit: 'cover' }} />
            ) : (
              <div className="sidebar-avatar" style={{ background: corAvatar(usuario.email) }}>
                {iniciais(usuario.nome)}
              </div>
            )}
            <div className="sidebar-perfil-info">
              <div className="sidebar-perfil-nome">{usuario.nome}</div>
              <div className="sidebar-perfil-email">{usuario.email}</div>
            </div>
            <span className={`sidebar-seta ${menuUsuarioAberto ? 'aberto' : ''}`} style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10 }}>▲</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
